import AdminResellerForm from '@/pages/admin-reseller-form/AdminResellerForm';

export default AdminResellerForm;
